module.exports = __webpack_public_path__ + "04_short_beige.6498768f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_short_beige.png
// module id = LrmD
// module chunks = 0